export const CONTRACTING_PARTY_FORMS = {
  INDIVIDUAL: 'Individual',
  SELF_EMPLOYED: 'Self-employed',
  SOLE_PROPRIETOR: 'Sole proprietor',
  LEGAL_ENTITY: 'Legal entity',
};

const CONTRACTING_PARTY_FORM_ALIASES = Object.fromEntries(
  Object.entries(CONTRACTING_PARTY_FORMS).map(([key]) => [key, key.toString()]),
);

export const BUSINESS_REGISTRATION_COUNTRY_REQUIRED_FORMS = [
  CONTRACTING_PARTY_FORM_ALIASES.SELF_EMPLOYED,
  CONTRACTING_PARTY_FORM_ALIASES.SOLE_PROPRIETOR,
  CONTRACTING_PARTY_FORM_ALIASES.LEGAL_ENTITY,
];
